import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDispatchHistoryList } from "../../../../actions/mmActions";
import { getOpenLoadBatchIdDialogSlot, handleLoadBatchIdDialogSlot, showAlertSnackbar } from "../../../../reducers/uiSlice";
import UniDialog from "../../../../components/Common/UniDialog";
import SelectDispatchHistory from "../SelectDispatchHistory";
import { getSortingHistory, getSortingHistoryList, removedispatchhistory, removesortinghistorybyid } from "../../../../actions/saActions";
import * as mmHelper from '../../../../network/mmHelper';
import { useTranslation } from "react-i18next";
import _ from 'lodash';
import { DialogContent, DialogContentText } from '@material-ui/core';
import { isJsonString } from "../../../../utilities/common";

export function LoadDispatchHistoryModalSlot(props){
    const {t} = useTranslation('dialog');
    const dispatch = useDispatch();
    
    const openLoadBatchIdDialog = useSelector(getOpenLoadBatchIdDialogSlot);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const {isLoading, dispatchHistoryList} = props
    const [loadBatchIds, setLoadBatchIds] = useState("");
    const [selectedSlots, setSelectedSlots] = useState("");
    const [slotFormatted, setSlotFormatted] = useState('');

    useEffect(() => {
        setLoadBatchIds(loadBatchIds);
    }, []);

    const handleDeleteOpen = () => {
        setDeleteOpen(true);
    }

    const handleDeleteClose = () => {
        setDeleteOpen(false);
    }

    const handleRemoveSortingHistory = async (id) => {
        try {
            await Promise.all([
                dispatch(removesortinghistorybyid(id)),
                dispatch(removedispatchhistory(id)),
            ]);
            dispatch(showAlertSnackbar({ message: t('delete_dispatch_history_success'), type: 'info' }))
        } catch (error) {
            dispatch(showAlertSnackbar({ message: t('delete_dispatch_history_failed'), type: 'info' }))
        } finally {
            fetchDispatchHistoryList();
            handleDeleteClose();
        }
    }

    return (
        <UniDialog
            title={t('load_dispatch_history_title')}
            maxWidth='sm'
            fullWidth
            open={openLoadBatchIdDialog}
            onClose={()=>dispatch(handleLoadBatchIdDialogSlot(false))}
            openFunction={fetchDispatchHistoryList}
            buttons={[
                {   
                    id: 'load_dispatch_history_delete_button',
                    variant: 'contained',
                    color: 'primary',
                    text: t('delete_dispatch_history'),
                    action: () => {
                        handleDeleteOpen()
                    }
                },
                {
                    id: 'load_dispatch_history_copy_button',
                    color: 'primary',
                    text: t('copy_configuration'),
                    action: () => {
                        navigator.clipboard.writeText(slotFormatted.toString())
                        dispatch(showAlertSnackbar({ message: t('common:copied'), type: 'info' }))
                    }
                },
                {
                    id: 'load_dispatch_history_load_button',
                    color: 'primary',
                    text: t('load'),
                    action: () => dispatch(handleLoadBatchIdDialogSlot(false))
                }
            ]}
        >
            <UniDialog
                open={deleteOpen}
                title={t('load_dispatch_history_title')}
                maxWidth='sm'
                fullWidth
                onClose={handleDeleteClose}
                buttons={[
                    {
                        id: 'dispatch_history_deletedialog_close_button',
                        variant: 'contained',
                        color: 'primary',
                        text: t('cancel'),
                        action: () => {
                            handleDeleteClose()
                        }
                    },
                    {
                        id: 'dispatch_history_remove_button',
                        color: 'primary',
                        text: t('ok'),
                        action: () => {
                            handleRemoveSortingHistory(selectedSlots.id);
                        }
                    }
                ]}
            >
                <DialogContent>
                    <DialogContentText>
                    {t('sure_to_delete')}"{selectedSlots.long_name}"
                    </DialogContentText>
                </DialogContent>

            </UniDialog>
            <SelectDispatchHistory 
                data={dispatchHistoryList}
                isLoading={isLoading}
                handleSelectedDispatchGroup={(ids)=>setLoadBatchIds(ids)}
                handleSelectedSlots={handleSelectedSlots}
                saveHistoryId={saveHistoryId}
            />
        </UniDialog>
    )

    function saveHistoryId(id) {
        props.saveHistoryId(id);
    }

    function handleExportConfiguration(slotConfiguration) {
        setSlotFormatted(slotConfiguration.join('\n'));
    }

    function handleSelectedSlots(id) {       
        dispatch(getSortingHistory(id))
        .then((res) => {
            props.handleManualLoadingDisable(true);
            setSelectedSlots(res.data);
            let slotConfig = [];
            let slotConfigCopy = [];
            if(isJsonString(res.data.slot_configuration)) {
                let resModify = JSON.parse(res.data.slot_configuration);
                let sortable = [];
                let configurationList = [];
                for (var key in resModify) {
                    if(resModify[key]!=='undefined') {
                        sortable.push([key, resModify[key]]);
                        configurationList.push(key + ':' + resModify[key]);
                    }
                }
                props.setSlotConfigurationList(configurationList, 'object');
                sortable.sort(function(a, b) {
                    return Number(a[1]) - Number(b[1]);
                });
                handleExportConfiguration(sortable)
            } else {
                props.setSlotConfigurationList(res.data.slot_configuration, 'string');
                slotConfig = res.data?.slot_configuration.split(",");
                if(slotConfig?.length > 0) {
                    slotConfigCopy = slotConfig.filter((slot) => {
                        // Transfer from string "serviceNumber: slotCode" to array [serviceNumber, slotCode].
                        let slotArr = slot.split(":");
                        // Filter "undefined" slot code.
                        if(slotArr[1]!=='undefined') {
                            return slotArr[0] + ':' + slotArr[1];
                        }
                    });
                    // Sort by slot code.
                    slotConfigCopy.sort((slot1, slot2) => {
                        return Number(slot1.split(":")[1]) - Number(slot2.split(":")[1]);
                    })
                    handleExportConfiguration(slotConfigCopy)
                }
            }
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('loading_failed'), type: 'error'}))
        })
    }

    function fetchDispatchHistoryList(){
        if(!isLoading)
            dispatch(getSortingHistoryList(props.branch));
            dispatch(getDispatchHistoryList(props.branch));
    }
}